import React, { useState } from 'react';
import PatientForm from './PatientForm';

export default function PatientsView({ patients = [], onCreate, onUpdate, onDelete, onBack }) {
  const [editing, setEditing] = useState(null);

  return (
    <div className="patients-view" style={{ padding: '20px' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginBottom: '18px', alignItems: 'center' }}>
        <h2 style={{ margin: 0 }}>Patients</h2>
        <div>
          <button type="button" onClick={() => { setEditing({ name: '', prenom: '', sexe: '', dateNaissance: '', age: '', phone: '', adresse: '', insuranceName: '', insuranceNumber: '', nomMere: '', nomJeuneFille: '', etatCivil: '', signesVitaux: { ta: '', temp: '', fc: '', fr: '', poids: '', taille: '' }, infirmiereSignature: '' }); setTimeout(() => { const el = document.querySelector('.patient-form'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 80); }}>Ajouter un patient</button>
          <button type="button" onClick={async () => {
            const samples = [
              { name: 'Dupont', prenom: 'Jean', sexe: 'M', dateNaissance: '1984-03-12', age: 42, phone: '+33 6 12 34 56 78', adresse: '1 Rue de la Paix, Paris', nomMere: 'Marie Dupont', nomJeuneFille: '', etatCivil: 'marie', signesVitaux: { ta: '12/8', temp: '37.2', fc: '78', fr: '18', poids: '73', taille: '178' }, infirmiereSignature: 'Infirmière Martin' },
              { name: 'Curie', prenom: 'Marie', sexe: 'F', dateNaissance: '1990-11-07', age: 36, phone: '+33 6 98 76 54 32', adresse: '2 Avenue des Sciences, Paris', nomMere: 'Eve Curie', nomJeuneFille: '', etatCivil: 'celibataire', signesVitaux: { ta: '11/7', temp: '36.8', fc: '74', fr: '16', poids: '62', taille: '165' }, infirmiereSignature: 'Infirmière Dupont' }
            ];
            for (const s of samples) {
              // eslint-disable-next-line no-unused-expressions
              onCreate && await onCreate(s);
            }
          }} style={{ marginLeft: 8 }}>Ajouter des données de test</button>
          <button onClick={onBack} style={{ marginLeft: 8 }}>Retour</button>
        </div>
      </div>

      <div style={{ display: 'grid', gap: '14px' }}>
        {patients.map(p => (
          <div key={p.id} style={{ padding: '16px', borderRadius: '14px', border: '1px solid #d6d6d6', backgroundColor: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '10px', alignItems: 'start' }}>
              <div>
                <h3 style={{ margin: '0 0 8px 0' }}>{p.prenom ? `${p.prenom} ${p.name}` : p.name}</h3>
                <div style={{ color: '#475569', marginTop: '6px' }}><strong>Code : </strong>{p.code || '—'}</div>
                {p.insurance && <div style={{ color: '#475569', marginTop: '6px' }}><strong>Assurance : </strong>{p.insurance.name} · Code {p.insurance.code}</div>}
                {p.orientedService && <div style={{ color: '#0d3b66', marginTop: '6px' }}><strong>Orienté vers : </strong>{p.orientedService}</div>}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '8px' }}>
                  <div><strong>Sexe</strong><div>{p.sexe}</div></div>
                  <div><strong>Naissance</strong><div>{p.dateNaissance || '—'}</div></div>
                  <div><strong>Inscription</strong><div>{p.dateInscription || '—'}</div></div>
                  <div><strong>Âge</strong><div>{p.age || '—'} ans</div></div>
                  <div><strong>Tél.</strong><div>{p.phone || '—'}</div></div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                <button onClick={() => setEditing(p)}>Éditer</button>
                <button onClick={() => onDelete && onDelete(p.id)}>Supprimer</button>
              </div>
            </div>
            <div style={{ marginTop: '12px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div>
                <strong>Adresse</strong>
                <div>{p.adresse || '—'}</div>
              </div>
              <div>
                <strong>État civil</strong>
                <div>{p.etatCivil || '—'}</div>
              </div>
              <div>
                <strong>Nom mère</strong>
                <div>{p.nomMere || '—'}</div>
              </div>
              <div>
                <strong>Signature infirmière</strong>
                <div>{p.infirmiereSignature || '—'}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <PatientForm
          patient={editing}
          onCancel={() => setEditing(null)}
          onSave={async (data) => {
            if (data.id) {
              await onUpdate(data);
            } else {
              await onCreate(data);
            }
            setEditing(null);
          }}
        />
      )}
    </div>
  );
}
